module.exports = __webpack_public_path__ + "img/6.a94ae19a.png";